export const enum USER_TYPE {
  FL = 1,
  UL = 2,
  IP = 3,
  SZ = 4,
}

export const enum ORGANIZATION_TYPE {
  SUMMIT = 1,
  DOBROZAIM = 2,
}

export const USER_TYPE_LABELS = {
  [USER_TYPE.FL]: 'Физическое лицо',
  [USER_TYPE.UL]: 'Юридическое лицо',
  [USER_TYPE.IP]: 'Индивидуальный предприниматель',
  [USER_TYPE.SZ]: 'Самозанятый',
}

export const ORGANIZATION_TYPE_LABELS = {
  [ORGANIZATION_TYPE.SUMMIT]: 'ООО МФК «Саммит»',
  [ORGANIZATION_TYPE.DOBROZAIM]: 'ООО КА «ДОБРОЗАЙМ»',
}

export const enum PAYMENT_TYPE {
  PERCENTAGE = 1,
  CAPITALIZATION = 2,
  PRINCIPAL_OUTFLOW = 3,
  PRINCIPAL_REPAYMENT = 4,
}
